/** Bump when product-profile FE changes ship — visible in console to confirm deploy. */
export const PRODUCT_PROFILE_FE_BUILD = '2026-05-20-incumbent-signals';

function toLines(value) {
  if (Array.isArray(value)) {
    return value.map((v) => String(v).trim()).filter(Boolean);
  }
  if (typeof value === 'string' && value.trim()) {
    return value
      .split('\n')
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
}

/** Summarize incumbent_* fields on an API profile object. */
export function incumbentFieldsFromProfile(profile) {
  const p = profile || {};
  return {
    hasBoostKey: Object.prototype.hasOwnProperty.call(p, 'incumbent_boost_signals'),
    hasPenaltyKey: Object.prototype.hasOwnProperty.call(p, 'incumbent_penalty_signals'),
    boostCount: toLines(p.incumbent_boost_signals).length,
    penaltyCount: toLines(p.incumbent_penalty_signals).length,
    boostSample: toLines(p.incumbent_boost_signals).slice(0, 3),
    penaltySample: toLines(p.incumbent_penalty_signals).slice(0, 3),
  };
}

/** Count non-empty lines in form textareas. */
export function incumbentLinesFromFormText(boostText, penaltyText) {
  return {
    boostLines: toLines(boostText).length,
    penaltyLines: toLines(penaltyText).length,
  };
}

export function logProductProfile(event, payload = {}) {
  console.log('[ProductProfile]', {
    event,
    build: PRODUCT_PROFILE_FE_BUILD,
    host: typeof window !== 'undefined' ? window.location.host : undefined,
    ...payload,
  });
}
